import React from 'react';
import loadable from '@loadable/component';

const Root = loadable(() => import('./Root'));
const EmailForm = loadable(() => import('./EmailForm'));
const NewUserPasswordForm = loadable(() => import('./NewUserPasswordForm'));
const PasswordForm = loadable(() => import('./PasswordForm'));

export const ResetPasswordRoute = () => ({
  path: 'reset-password',

  component: props => <Root {...props} />,

  indexRoute: { component: props => <EmailForm {...props} /> },

  childRoutes: [
    {
      path: 'welcome/:resetToken',
      component: props => <NewUserPasswordForm {...props} />,
    },
    {
      path: ':resetToken',
      component: props => <PasswordForm {...props} />,
    },
  ],
});
